import { useMemo } from 'react';
import { Option, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ILockReasonTypeDto } from '@/dtos';

export const GET_LOCK_REASONS_KEY = 'GET_LOCK_REASONS_KEY';

export const useGetLockReasons = () => {
  const { data, isLoading } = useQuery(
    [GET_LOCK_REASONS_KEY],
    () => api.get<ILockReasonTypeDto[]>(API_URL.ENUMS_LOCK_REASONS)
  );

  const lockReasonOptions = useMemo<Option[]>(
    () =>
      (data?.data || []).map((item) => ({
        key: item.reason || '',
        value: item.reason || '',
        title: item.description || item.reason || '',
      })),
    [data]
  );

  return { lockReasonOptions, isLoading };
};
